import React, {useCallback, useEffect, useState} from 'react';
import {NavLink, useParams} from "react-router-dom";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {officeMemberResultCollectionType, officeMemberResultType} from "../../../../types/Api/OfficeMemberResultType";
import {office} from "../../../../models/office";
import {officeMember} from "../../../../models/officeMember";
import {officeMemberHydrator} from "../../../../models/hydrator/officeMemberHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {OfficeMemberList} from "../../../../components/admin/office/OfficeMemberList";
import {scrollTo} from "../../../../service/ToolsService";
import {OfficeListBox} from "../../../../components/admin/office/OfficeListBox";

export const Show = () => {
  const uuid: undefined | string = useParams().uuid;

  const [office, setOffice] = useState(undefined as undefined | office);
  const [officeMember, setOfficeMember] = useState([] as officeMember[]);
  const [loading, setLoading] = useState(false);

  const findOffice = useCallback(() => {
    if (uuid) {
      const apiFilters: ApiQueryParam = new ApiQueryParam();

      apiFilters.addFilter({
        field: 'officeId',
        op: 'eq',
        value: uuid
      });

      apiFilters.addSort({
        by: 'order',
        direction: 'ASC'
      });

      setLoading(true);

      const result = ApiService.get(`/office-member`, apiFilters) as Promise<officeMemberResultCollectionType>;

      result
        .then((officeMemberResultCollection: officeMemberResultCollectionType) => {
          setOfficeMember(officeMemberResultCollection._embedded["office-members"].map((om: officeMemberResultType) => {
            return officeMemberHydrator.hydrate(om);
          }));
        })
        .catch((e: any) => {
          console.log(e);
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [uuid])

  useEffect(() => {
    setOffice(
      officeMember.length > 0 ? officeMember[0].office : undefined
    )
  }, [officeMember])

  useEffect(() => {
    findOffice()
  }, [findOffice, uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && office && (
        <>
          <BoxTitle title="Bureau"/>

          <div className="w100 max-w400px mb-3">
            <OfficeListBox office={office}/>
          </div>

          <div className="w100">
            <OfficeMemberList officeMember={officeMember}/>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <NavLink to={`/admin/office/office`} onClick={scrollTo} className="btn btn-sm btn-info me-1">Retour aux bureaux</NavLink>
            </div>
            <div>
              <NavLink to={`/admin/office/office/edit/${office.officeId}`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/>Modifier
              </NavLink>

              <NavLink to={`/admin/office/office/order`} onClick={scrollTo} className="btn btn-sm btn-danger">
                <i className="fa-solid fa-solid fa-xmark me-1"/>Supprimer
              </NavLink>
            </div>
          </div>
        </>
      )}
    </>
  );
}
